import removeClass from 'remove-class';
import addClass    from 'add-class';
import delegate    from 'delegate';

class SlugButtonGroup {

	constructor(buttonsContainer, buttonSelector, options) {
		this.buttonsContainer = buttonsContainer;
		this.buttonSelector = buttonSelector;

		if (options) {
			if (typeof options === 'function')
				this.onSelect(options);
			else if (options.onSelect)
				this.onSelect(options.onSelect);
		}
	}

	onSelect(listener) {
		// This assumes the button elements are siblings of each other
		delegate(this.buttonsContainer, this.buttonSelector, 'click', (event) => {
			// Don't do anything if this button group is disabled
			if (this.disabled)
				return;

			// Don't do anything if this button is disabled
			if (event.delegateTarget.hasAttribute('disabled'))
				return;

			// Find previously active class and deactivate it
			var buttons = this.buttons;
			for (let button of buttons)
				removeClass(button, 'active');

			// Find the index of the newly activated button
			var currentIndex = buttons.indexOf(event.delegateTarget);

			// Add class to the clicked one
			addClass(event.delegateTarget, 'active');

			// Determine slug and call the callback function
			listener(event.delegateTarget.dataset.slug, currentIndex);
		});
	}

	count() {
		return this.buttonsContainer.querySelectorAll(this.buttonSelector).length;
	}

	getActiveIndex() {
		var activeButton = this.buttonsContainer.querySelector(this.buttonSelector + '.active');
		if (activeButton)
			return this.buttons.indexOf(activeButton);
		else
			return 0;
	}

	getActiveSlug() {
		var activeButton = this.buttonsContainer.querySelector(this.buttonSelector + '.active');
		if (activeButton)
			return activeButton.dataset.slug;
		else
			return '';
	}

	get buttons() {
		return [].slice.call(this.buttonsContainer.querySelectorAll(this.buttonSelector));
	}

	disableAllButtons() {
		var buttons = this.buttonsContainer.querySelectorAll(this.buttonSelector);
		for (let button of buttons)
			button.setAttribute('disabled', 'disabled');
	}

	enableAllButtons() {
		var buttons = this.buttonsContainer.querySelectorAll(this.buttonSelector);
		for (let button of buttons)
			button.removeAttribute('disabled');
	}

	disable() {
		this.disabled = true;
	}

	enable() {
		this.disabled = false;
	}

	static create() {
		return new SlugButtonGroup(...arguments);
	}

}

Object.defineProperty(SlugButtonGroup, 'LEFT', {
	value: -1,
	writable: false,
	enumerable: true,
	configurable: false,
});

Object.defineProperty(SlugButtonGroup, 'RIGHT', {
	value: 1,
	writable: false,
	enumerable: true,
	configurable: false,
});

export default SlugButtonGroup;



// WEBPACK FOOTER //
// ./assets/scripts/slug-button-group.js